const accordions = Array.from(document.querySelectorAll('.block--dropdown-card-group'));
if (typeof(accordions) != 'undefined' && accordions != null) {
    new Accordion(accordions, {
        elementClass: 'block--dropdown-card-item',
        triggerClass: 'block--dropdown-card-item-trigger',
        panelClass: 'block--dropdown-card-content',
        showMultiple: true,
    });
}